import React, { useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SavedContacts from "./screens/SavedContacts";
import SignIn from "./screens/Auth/SignIn";
import { AuthContext } from "./_hooks/useAuthContext";
import { navigateRoutes } from "./_config/route";
import { BaseRoute, PrivateRoute, PublicRoute } from "./_config/RouteConfig";
function App() {
  const { setOfficeInitialized } = useContext(AuthContext);

  // Initialize Office JS
  useEffect(() => {
    const initializeOffice = async () => {
      try {
        // Check if Office.js is available
        if (window.Office) {
          await window.Office.onReady().then(() => {
            setOfficeInitialized(true);
            console.log("Office.js initialized");
          });
        } else {
          console.log("Office.js not available. Running in development mode.");
          setOfficeInitialized(false);
        }
      } catch (error) {
        console.error("Error initializing Office.js:", error);
      }
    };

    initializeOffice();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<BaseRoute />} />
        <Route path="/" element={<PublicRoute />}>
          <Route path={navigateRoutes.signIn} element={<SignIn />} />
        </Route>

        <Route path="/" element={<PrivateRoute />}>
          <Route
            path={navigateRoutes.savedContacts}
            element={<SavedContacts />}
          />
        </Route>

        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
